var indexOf = require('./indexOf');

    /**
     * Remove a single item from the array.
     * (it won't remove duplicates, just a single item)
     */
    function remove(arr, item){
        var idx = indexOf(arr, item);
        if (idx !== -1) arr.splice(idx, 1);
    }

    module.exports = remove;




//////////////////
// WEBPACK FOOTER
// ./~/mout/array/remove.js
// module id = 1560
// module chunks = 0 1 2